import type { ReactNode } from 'react'

export function HighlightedText({ text }: { text: string }): ReactNode {
  const parts = text.split(/\{\{(.*?)\}\}/)
  return parts.map((part, i) => {
    if (i % 2 === 1) {
      return (
        <span
          key={i}
          className="text-ink rounded px-1 py-0.5 font-bold"
          style={{
            fontFamily: 'var(--font-handwritten)',
            fontSize: '1.25em',
            backgroundColor: 'rgba(85, 225, 255, 0.25)',
          }}
        >
          {part}
        </span>
      )
    }
    return <span key={i}>{part}</span>
  })
}
